/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateCustomFieldValueInput = {
    id?: string | null | undefined;
    entityId?: string | null | undefined;
    entityType?: string | null | undefined;
    key?: string | null | undefined;
    value?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type updateCustomFieldValueMutationVariables = {
    input: UpdateCustomFieldValueInput;
};
export type updateCustomFieldValueMutationResponse = {
    readonly updateCustomFieldValue: {
        readonly customFieldValue: {
            readonly node: {
                readonly id: string;
                readonly key: string;
                readonly displayName: string;
                readonly value: string | null;
            } | null;
        } | null;
    } | null;
};
export type updateCustomFieldValueMutation = {
    readonly response: updateCustomFieldValueMutationResponse;
    readonly variables: updateCustomFieldValueMutationVariables;
};



/*
mutation updateCustomFieldValueMutation(
  $input: UpdateCustomFieldValueInput!
) {
  updateCustomFieldValue(input: $input) {
    customFieldValue {
      node {
        __typename
        id
        key
        displayName
        value
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCustomFieldValueInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateCustomFieldValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCustomFieldValuePayload",
        "kind": "LinkedField",
        "name": "updateCustomFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomFieldValueV2TypeEdge",
            "kind": "LinkedField",
            "name": "customFieldValue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateCustomFieldValueMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateCustomFieldValuePayload",
        "kind": "LinkedField",
        "name": "updateCustomFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomFieldValueV2TypeEdge",
            "kind": "LinkedField",
            "name": "customFieldValue",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "updateCustomFieldValueMutation",
    "operationKind": "mutation",
    "text": "mutation updateCustomFieldValueMutation(\n  $input: UpdateCustomFieldValueInput!\n) {\n  updateCustomFieldValue(input: $input) {\n    customFieldValue {\n      node {\n        __typename\n        id\n        key\n        displayName\n        value\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '471d7a9cbd1115cc4ca4cc648127ac61';
export default node;
